import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  Box,
  Button,
  ButtonGroup,
  ClickAwayListener,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import languages from '../../../../helpers/utils/languages';
import { blue, green, grey, orange, pink, red } from '@mui/material/colors';
import {
  StyledTableCell,
  StyledTableRow,
} from '../../../../helpers/themes/TableTheme.jsx';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

const DisplayContactType = ({ template }) => {
  const types = template?.contactType?.map((item) => item?.codeBO);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 3,
      }}
    >
      {types?.includes('C') && (
        <Box
          sx={{
            backgroundColor: types?.includes('C') ? orange[200] : null,
            borderRadius: 2,
          }}
        >
          <Typography
            sx={{
              px: 2,
              py: 1,
              fontSize: 14,
            }}
          >
            {types?.includes('C') ? 'Part.' : ''}
          </Typography>
        </Box>
      )}
      {types?.includes('P') && (
        <Box
          sx={{
            backgroundColor: blue[200],
            borderRadius: 2,
          }}
        >
          <Typography
            sx={{
              px: 2,
              py: 1,
              fontSize: 14,
            }}
          >
            Pro.
          </Typography>
        </Box>
      )}
      {types?.includes('M') && (
        <Box
          sx={{
            backgroundColor: pink[100],
            borderRadius: 2,
          }}
          display={types?.includes('M')}
        >
          <Typography
            sx={{
              px: 2,
              py: 1,
              fontSize: 14,
            }}
          >
            MP
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export const TemplateRow = ({ template, onEdit, onView, key, onDelete }) => {
  const [openMenu, setOpenMenu] = useState(false);
  const lastUpdate = new Date(template.updatedAt);
  const createdAt = new Date(template?.createdAt);

  const langRow = languages?.find(
    ({ code2 }) => code2 === template?.language?.toUpperCase()
  );

  const chooseColor = (value) => {
    let color;
    switch (value) {
      case 'SAV':
        color = green[100];
        break;
      case 'SLO':
        color = blue[100];
        break;
      case 'SCO':
        color = red[100];
        break;
      case 'C':
        color = orange[200];
        break;
      case 'P':
        color = blue[200];
        break;
      case 'M':
        color = pink[100];
        break;
      case false:
        color = blue[500];
        break;
      case true:
        color = grey[600];
        break;
      default:
        color = grey[300];
        break;
    }
    return color;
  };

  const displayStores = (stores) => {
    let text = '';
    if (stores?.length < 1) {
      return 'Pas de magasin';
    }
    if (stores?.length === 1) {
      return stores[0]?.shortName;
    }
    if (stores?.length <= 3) {
      stores?.map((value, index) => {
        if (index !== stores?.length - 1) {
          text = text + value?.shortName + ', ';
        } else {
          text = text + value?.shortName;
        }
      });
      return text;
    }
    for (let index = 0; index <= 2; index++) {
      text = text + stores[index]?.shortName + ', ';
    }
    text = text + ` ...`;
    return text;
  };

  return (
    <StyledTableRow>
      {/*Reference*/}
      <StyledTableCell key={key}>
        {template?.reference || 'Pas de référence'}
      </StyledTableCell>
      {/*Titre*/}
      <StyledTableCell key={key}>
        {template?.name || 'Pas de titre'}
      </StyledTableCell>
      {/*Store*/}
      <StyledTableCell key={key}>
        {displayStores(template?.store)}
      </StyledTableCell>
      {/*Langue*/}
      <StyledTableCell key={key}>
        {langRow?.code2 || 'Pas de langue'}
      </StyledTableCell>
      {/* Service*/}
      <StyledTableCell key={key}>
        <Box
          sx={{
            width: '75%',
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: chooseColor(template?.service?.code),
            borderRadius: 2,
          }}
        >
          <Typography sx={{ px: 2, py: 1, fontSize: 14 }}>
            {template?.service?.code || 'Pas de service'}
          </Typography>
        </Box>
      </StyledTableCell>
      {/*Client*/}
      <StyledTableCell key={key}>
        <DisplayContactType template={template} />
      </StyledTableCell>
      {/*Status*/}
      <StyledTableCell key={key}>
        <Box
          sx={{
            width: '100%',
            border: 4,
            borderColor: chooseColor(template?.isDraft),
            borderRadius: 2,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Typography
            color={chooseColor(template?.isDraft)}
            sx={{
              px: 1,
              py: 0.5,
              fontSize: 14,
            }}
          >
            {template?.isDraft ? 'Brouillon' : 'Actif'}
          </Typography>
        </Box>
      </StyledTableCell>
      {/*Author*/}
      <StyledTableCell key={key}>
        {template?.author?.firstName} {template?.author?.lastName}
      </StyledTableCell>
      {/*Created at*/}
      <StyledTableCell key={key}>
        {createdAt.toLocaleDateString('fr-FR')} à{' '}
        {createdAt.toLocaleTimeString('fr-FR', { timeStyle: 'short' })}
      </StyledTableCell>
      {/*Last update*/}
      <StyledTableCell key={key}>
        {lastUpdate.toLocaleDateString('fr-FR')} à{' '}
        {lastUpdate.toLocaleTimeString('fr-FR', { timeStyle: 'short' })}
      </StyledTableCell>
      {/*Editer*/}
      <StyledTableCell key={key}>
        <Box
          sx={{
            display: 'flex',
            minWidth: '210px',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: 1,
          }}
        >
          <ClickAwayListener onClickAway={() => setOpenMenu(false)}>
            <ButtonGroup variant="outlined" color="primary">
              {openMenu && (
                <Button color="error" onClick={() => onDelete()}>
                  <DeleteIcon fontSize="small" color="error" />
                </Button>
              )}
              {openMenu && (
                <Button onClick={() => onEdit()}>
                  <EditIcon fontSize="small" />
                </Button>
              )}
              {openMenu && (
                <Button onClick={() => onView()}>
                  <VisibilityIcon fontSize="small" />
                </Button>
              )}
              <Button
                variant={openMenu ? 'outlined' : 'text'}
                color={openMenu ? 'info' : 'primary'}
                onClick={() => setOpenMenu(!openMenu)}
              >
                {openMenu ? (
                  <ArrowRightIcon fontSize="small" />
                ) : (
                  <MoreHorizIcon fontSize="small" />
                )}
              </Button>
            </ButtonGroup>
          </ClickAwayListener>
        </Box>
      </StyledTableCell>
    </StyledTableRow>
  );
};
